import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faArrowRight, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { LanguageService } from "../services/language.service";


@Component({
    selector: "ell-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    imports: [CommonModule, FormsModule, RouterLink, FontAwesomeModule],
    standalone: true,
})
export class HomeComponent {
    public faArrowRight = faArrowRight;
    public faGlobe = faGlobe;

    constructor(public languageService: LanguageService) {
    }

    toggleLanguage() {
        this.languageService.set($localize`:Target language code|:nl`).subscribe(() => {
            // reload the application to make the server route
            // to the different language version
            document.location.reload();
        });
    }
}
